export default __webpack_public_path__ + "static/spinner-360-b3ee1accf99f5b48fce2a2a28ade9ff1.gif";